import React, { useState, useContext } from "react";
import dynamic from "next/dynamic";
import Drawer from "../../Drawer";
import { handleErrors, nonRedirectFetcher } from "../../../utils/errors";
import StatusMessage from "../../StatusMessage";
import { NotificationsContext } from "../../NotificationsProvider";
import { exportCustomerToPlatforms } from "../../ExportCustomerInput";
const AddressForm = dynamic(() => import('./AddressForm'), {ssr: false})
import useSWR from "swr";

const AddCustomerDrawer = ({onClose, onSuccess}) => {
    const [formError, setFormError] = useState();
    const notificationCtx = useContext(NotificationsContext);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const {data: syncData} = useSWR("/api/settings/shopify", nonRedirectFetcher, {
        revalidateOnFocus: false
    });

    const {data: hubspotData} = useSWR("/api/settings/hubspot", nonRedirectFetcher, {
        revalidateOnFocus: false
    });

    const saveDetails = ({ value, callback, onError }) => {
        const { shop_domain, shopify_customer_id, export_to_hubspot, ...customerData } = value;
        fetch('/api/customers/add', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(customerData),
        }).then(handleErrors)
            .then((data) => {
                const customerId = data?.id;
                const hasExports = shop_domain || export_to_hubspot;
                if (hasExports && customerId) {
                    exportCustomerToPlatforms(customerId, {
                        shopDomain: shop_domain,
                        shopifyCustomerId: shopify_customer_id,
                        exportToHubSpot: export_to_hubspot,
                    }).catch(err => notificationCtx.showNotification(err));
                }
                notificationCtx.showNotification({message: 'Customer created!'});
                if (callback) callback(data);
                return data;
            })
            .catch(err => {
                onError && onError();
                setFormError(err);
            });
    };
    return (
        <Drawer
            title="Add Customer"
            onClose={onClose}
        >
            {formError && (<StatusMessage apiError={formError} margin={{top: 'small'}} />)}
            <AddressForm
                onSubmit={(event) => {
                    setIsSubmitting(true);
                    saveDetails({
                        value: event.value,
                        callback: data => {
                            setIsSubmitting(false);
                            onSuccess(data);
                        },
                        onError: () => setIsSubmitting(false)
                    });
                }}
                onCancel={onClose}
                companyNameRequired={true}
                isNewAddress={true}
                isCtaLoading={isSubmitting}
                syncData={syncData && syncData?.length > 0 && syncData}
                hubspotConnected={hubspotData?.connected}
            />
        </Drawer>
    );
}

export default AddCustomerDrawer;
